import { render, staticRenderFns } from "./DoctorSpecialities.vue?vue&type=template&id=cdc00274&scoped=true&"
import script from "./DoctorSpecialities.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorSpecialities.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorSpecialities.vue?vue&type=style&index=0&id=cdc00274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc00274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdc00274')) {
      api.createRecord('cdc00274', component.options)
    } else {
      api.reload('cdc00274', component.options)
    }
    module.hot.accept("./DoctorSpecialities.vue?vue&type=template&id=cdc00274&scoped=true&", function () {
      api.rerender('cdc00274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/DoctorSpecialities.vue"
export default component.exports